/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Hub_AttentionInputs */

const en_us2_coaching_hub_attention = /** @type {(inputs: Coaching_Hub_AttentionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something new is waiting for you`)
};

const pt_br2_coaching_hub_attention = /** @type {(inputs: Coaching_Hub_AttentionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Há algo novo esperando por você`)
};

const pt_pt2_coaching_hub_attention = /** @type {(inputs: Coaching_Hub_AttentionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Há algo novo esperando por você`)
};

/** @type {(inputs: Coaching_Hub_AttentionInputs) => LocalizedString} */
const es_419_coaching_hub_attention = en_us2_coaching_hub_attention;

/** @type {(inputs: Coaching_Hub_AttentionInputs) => LocalizedString} */
const fr_fr2_coaching_hub_attention = en_us2_coaching_hub_attention;

/** @type {(inputs: Coaching_Hub_AttentionInputs) => LocalizedString} */
const de_de2_coaching_hub_attention = en_us2_coaching_hub_attention;

/** @type {(inputs: Coaching_Hub_AttentionInputs) => LocalizedString} */
const it_it2_coaching_hub_attention = en_us2_coaching_hub_attention;

/**
* | output |
* | --- |
* | "Something new is waiting for you" |
*
* @param {Coaching_Hub_AttentionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_hub_attention = /** @type {((inputs?: Coaching_Hub_AttentionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Hub_AttentionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_hub_attention(inputs)
	if (locale === "es-419") return es_419_coaching_hub_attention(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_hub_attention(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_hub_attention(inputs)
	if (locale === "de-DE") return de_de2_coaching_hub_attention(inputs)
	if (locale === "it-IT") return it_it2_coaching_hub_attention(inputs)
	return en_us2_coaching_hub_attention(inputs)
});
export { coaching_hub_attention as "coaching.hub_attention" }